export default "__VITE_ASSET__b08ed6f6__"